import { SyncHook } from "./syncHook.js";

//#region src/utils/hooks/asyncHook.ts
var AsyncHook = class extends SyncHook {
	emit(...data) {
		let result;
		const ls = Array.from(this.listeners);
		if (ls.length > 0) {
			let i = 0;
			const call = (prev) => {
				if (prev === false) return false;
				else if (i < ls.length) return Promise.resolve(ls[i++].apply(null, data)).then((result) => {
					if (result === void 0 || data.length === 1 && result === data[0]) return call(prev);
					return call(result);
				});
				else return prev;
			};
			result = call();
		}
		return Promise.resolve(result);
	}
};

//#endregion
export { AsyncHook };
//# sourceMappingURL=asyncHook.js.map